import { render, staticRenderFns } from "./EventAdd.vue?vue&type=template&id=0e3e5854&scoped=true"
import script from "./EventAdd.vue?vue&type=script&lang=js"
export * from "./EventAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e5854",
  null
  
)

export default component.exports